import { styled } from '@abyss/web/tools/styled';
import { Text } from '@abyss/web/ui/Text';

export const textContainer = (phoneScreen) => ({
  maxWidth: '839px',
  fontWeight: '$medium',
  fontSize: '$lg',
  lineHeight: '24px',
  color: '#4B4D4F ',
  '& strong': {
    fontWeight: '$medium',
  },
  ...(phoneScreen && {
    fontSize: '$md',
    fontWeight: '500',
    lineHeight: '20px',
  }),
});

export const StyledHeadingText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#323333;',
    marginTop: '16px',

    '@screen < $sm': {
      height: '24px',
      fontSize: '$md',
      lineHeight: '20px',
      display: 'block',
      marginBottom: '12px',
      marginTop: '16px',
    },
  },
});

export const StyledGeneratedAIText = styled(Text, {
  marginLeft: '8px',
  fontSize: 'xs',
  lineHeight: '14px',
  color: '#4B4D4F;',
  fontFamily: 'AbyssUHCSans',
  letterSpacing: '0px',
});
